module.exports = __webpack_public_path__ + "img/customer-a-040.5adf8159.png";